module.exports = __webpack_public_path__ + "static/media/magLogo.3c4347fa.png";